export default __webpack_public_path__ + "static/media/hand-peace.48de979e.svg";